import type { FC, ReactNode } from 'react'
import type { Comparison } from '@/types/content'

interface ComparisonTableProps {
    comparison: Comparison
}

const ComparisonTable: FC<ComparisonTableProps> = ({ comparison }): ReactNode => {
    return (
        <section aria-labelledby='comparison-heading' className='mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8'>
            <h2 id='comparison-heading' className='text-3xl font-bold sm:text-4xl' data-reveal>
                {comparison.caption}
            </h2>

            <div className='mt-8 overflow-x-auto rounded-3xl border border-border bg-white shadow-sm' data-reveal>
                <table className='w-full min-w-[44rem] border-collapse text-left'>
                    <caption className='sr-only'>
                        {comparison.caption}
                    </caption>

                    <thead>
                        <tr className='bg-navy text-white'>
                            {comparison.columns.map(column => (
                                <th key={column} scope='col' className='px-5 py-4 text-base font-bold'>
                                    {column}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {comparison.rows.map((row, rowIndex) => (
                            <tr key={`${row[0]}-${rowIndex}`} className='border-t border-border odd:bg-white even:bg-sand/60'>
                                {row.map((cell, cellIndex) => (
                                    cellIndex === 0
                                        ? (
                                            <th key={cellIndex} scope='row' className='px-5 py-4 align-top text-base font-bold text-navy'>
                                                {cell}
                                            </th>
                                        )
                                        : (
                                            <td key={cellIndex} className='px-5 py-4 align-top text-base'>
                                                {cell}
                                            </td>
                                        )
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    )
}

export default ComparisonTable
